/* tslint:disable */
/* eslint-disable */
/**
 * Hyper GES API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RoleDTO } from './RoleDTO';
import {
    RoleDTOFromJSON,
    RoleDTOFromJSONTyped,
    RoleDTOToJSON,
} from './RoleDTO';

/**
 * 
 * @export
 * @interface TenantDTO
 */
export interface TenantDTO {
    /**
     * 
     * @type {string}
     * @memberof TenantDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantDTO
     */
    name?: string;
    /**
     * 
     * @type {Array<RoleDTO>}
     * @memberof TenantDTO
     */
    roles?: Array<RoleDTO>;
}

/**
 * Check if a given object implements the TenantDTO interface.
 */
export function instanceOfTenantDTO(value: object): value is TenantDTO {
    return true;
}

export function TenantDTOFromJSON(json: any): TenantDTO {
    return TenantDTOFromJSONTyped(json, false);
}

export function TenantDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): TenantDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'roles': json['roles'] == null ? undefined : ((json['roles'] as Array<any>).map(RoleDTOFromJSON)),
    };
}

export function TenantDTOToJSON(value?: TenantDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
        'roles': value['roles'] == null ? undefined : ((value['roles'] as Array<any>).map(RoleDTOToJSON)),
    };
}

